import { useTranslation, Trans } from "react-i18next";
import { useSelector } from "react-redux";
import { appConfigSelectors } from "../store/appConfig/appConfigSlice";
import HelpPopover from "./help-popover";

interface RegexHelpProps {
    appendTo?: HTMLElement | HTMLDivElement | ((ref?: HTMLElement) => HTMLElement) | "inline" | undefined | null,
    regexAlwaysOn?: boolean,
}

const RegexHelp = (props: RegexHelpProps) => {
    const { appendTo, regexAlwaysOn } = props;

    const { t } = useTranslation();
    const deploymentConfigInfo = useSelector(appConfigSelectors.selectAppDeploymentInfo);

    const bodyContent = (
        <div className="regex-help">
            <div>{(appendTo === undefined && !regexAlwaysOn) ? t('regex.help.toggle') : t('regex.help.alwaysOn')}</div>
            {deploymentConfigInfo?.regexHelpUrl && (<div><Trans i18nKey="regex.help.website">This <a target="_blank" rel="noreferrer" href={deploymentConfigInfo.regexHelpUrl}>Regular Expression tester</a> can be used as an aid with writing Regular Expressions and for testing them.</Trans></div>)}
        </div>
    );

    return (
        <HelpPopover
            headerContent={<div>Regular expressions</div>}
            bodyContent={bodyContent}
            appendTo={appendTo}
            useAppendedStyle={appendTo !== undefined}
        />
    );
}

export default RegexHelp;
